import styled from 'styled-components'

import { Tokens } from '@/assets/tokens'

export const ThemeTableContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  height: fit-content;
  border-radius: ${Tokens.RadiusInput};
  background-color: ${Tokens.ColorWhite};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`

export const ShowActiveThemesWrapper = styled.div`
  padding: 1.2rem;
`

export const FormContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
  background-color: ${Tokens.ColorWhite};
  border-radius: ${Tokens.RadiusInput};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: 1280px) {
    max-width: 95%;
    padding: 20px;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 16px;
    margin: 0 8px;
  }
`

export const FiltersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border-bottom: 1px solid ${Tokens.ColorBorder};

  @media (max-width: 768px) {
    padding: 12px;
  }
`

export const TableSectionContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 1280px) {
    max-width: 95%;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    margin: 0 8px;
  }
`

export const TableDividerContainer = styled.div`
  padding: 0 24px;

  @media (max-width: 768px) {
    padding: 0 16px;
  }
`

export const PremiseSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const PremiseHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const PremiseLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
`

export const PremiseCounter = styled.span`
  font-size: 12px;
  color: #6b7280;
`

export const PremiseTextArea = styled.textarea`
  width: 100%;
  min-height: 80px;
  padding: 12px;
  border: 1px solid #dee2ef;
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: ${Tokens.ColorUIPrimary};
  }

  &:disabled {
    background-color: #f9fafb;
    color: #6b7280;
    cursor: not-allowed;
  }

  &::placeholder {
    color: #9ca3af;
  }
`
